// Regex used to remove valid non-numeric digits (whitespace, commas, $, %)
const validCharactersRegex = new RegExp("[\\s\\$%,]+", "g");

// Regex used to split every third number moving right to left
const splitNumericRegex = new RegExp("(?=(?:\\d{3})+$)", "g");

/**
 * Checks the value to make sure it is a number.
 * @returns {boolean}
 *     true/false if the value is a number.
 */
export function isNumber(value: any): boolean {
    return typeof value === "number" && !isNaN(value);
}

/**
 * Parse the specified value (assumed to be a string or null/undefined).
 * @returns {number}
 *      The parsed number, or NaN if parsing fails.
 */
export function parseNumber(value: any): number {
    if (value === null || value === undefined) { return null; }
    value = value.toString().replace(validCharactersRegex, "");
    if (!value.length) { return null; }
    const acctNeg = value.charAt(0) === "(" && value.charAt(value.length - 1) === ")";
    if (acctNeg) { value = "-".concat(value.substring(1, value.length - 1)); }
    return Number(value);
}

/**
 * Format the specified number to the specified format.
 * @returns {string}
 *      The formatted string.
 */
export function formatNumber(value: number, format: string): string {
    if (!isNumber(value)) { return ""; }
    if (typeof format === "string" && format.length > 0){
        const isAcct: boolean = format.charAt(0) === "(" && format.charAt(format.length - 1) === ")";
        if (isAcct) { format = format.substring(1, format.length - 1); }
        const formatType: string = format.charAt(0),
            precision: number = parseInt(format.substring(1), 10),
            parsed = isNumber(precision) ? value.toFixed(precision) : value;
        switch (formatType) {
            case "C":
            case "c":
                if (isAcct) {
                    return (parsed < 0 ? "($" : "$").concat(addCommas(parsed), (parsed < 0 ? ")" : ""));
                }
                else {
                    return (parsed < 0 ? "-$" : "$").concat(addCommas(parsed));
                }
            case "P":
            case "p":
                if (isAcct) {
                    return (parsed < 0 ? "(" : "").concat(addCommas(parsed), (parsed < 0 ? ")" : ""), " %");
                }
                else {
                    return (parsed < 0 ? "-" : "").concat(addCommas(parsed), " %");
                }
            case "N":
            case "n":
            default:
                if (isAcct) {
                    return (parsed < 0 ? "(".concat(parsed.toString().slice(1), ")") : parsed.toString());
                }
                return "".concat(parsed.toString());
        }
    }
    return "".concat(value.toString());
}

/**
 * Add commas to the number.
 * @returns {string}
 *      String formatted with commas.
 * @example
 *      5000.2512 => "5,000.2512"
 *      5000      => "5,000"
 */
function addCommas(value: number|string): string {
    const v = value.toString(),
        n = v[0] === "-",
        s = (n ? v.slice(1) : v).split("."),
        b = (s[0] || "").split(splitNumericRegex).join(",");
    return s[1] !== undefined ? b.concat(".", s[1]) : b;
}



// WEBPACK FOOTER //
// /Users/johng/dev/web-pli/util/number.ts